// extracted by mini-css-extract-plugin
module.exports = {"sitemapSearchBar":"SiteMapSayt_sitemapSearchBar__GEy_V","quickSearchBlock":"SiteMapSayt_quickSearchBlock__feDo_"};